import {
  FormAnnotation,
  FormCategoryTitle,
} from "@components/UI/atoms/Forms/FormComponents";
import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { StyledTag, StyledTagColor } from "../../StyledTag";

export type Props = {
  title: string | React.ReactNode;
  showRequiredTag?: boolean;
  required?: boolean;
  annotation?: string | JSX.Element;
  hasLongText?: boolean;
};

const useStyles = () => ({
  title: (theme: Theme) => ({
    color: theme.palette.secondary.contrastText,
    fontSize: "16px",
  }),
});

const FormSectionTitle: React.FC<Props> = ({
  title,
  showRequiredTag,
  required,
  annotation,
  hasLongText,
}) => {
  const { t } = useTranslation("common");
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));
  const isDisplayColumn = isMobile || hasLongText;
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection={isDisplayColumn ? "column" : "row"}
      alignItems={isDisplayColumn ? "column" : "start"}
      justifyContent={isDisplayColumn ? "flex-start" : "space-between"}
    >
      <FormCategoryTitle>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Box sx={classes.title} data-cy="form-category-title">
            {title}
          </Box>
          {showRequiredTag && (
            <StyledTag
              size="small"
              tagColor={
                required ? StyledTagColor.Pink : StyledTagColor.BrightGreen
              }
              label={t(required ? "required" : "optional")}
            />
          )}
        </Box>
      </FormCategoryTitle>
      {annotation && <FormAnnotation>{annotation}</FormAnnotation>}
    </Box>
  );
};

export default FormSectionTitle;
